<template>
  <div class="mt-8" :style="$vuetify.breakpoint.xs ? '' : ''">
    <!-- Nome da categoria e ver todos -->
    <div class="d-flex justify-space-between justify-center align-center">
      <div
        :class="[
          !relatedGames && 'nameCategory',
          $vuetify.breakpoint.xs
            ? 'subtitle-1 font-weight-bold my-1 pl-2'
            : 'text-h6 font-weight-bold my-3'
        ]"
        :style="!relatedGames && 'cursor: pointer;'"
        @click="() => !relatedGames && allGamesCategory(category.name, category.isViewFavorites)"
      >
        {{ relatedGames ? $t("newCasino.relatedGames") : category.name }}
      </div>

      <div style="filter: blur(0)" v-if="!relatedGames">
        <v-hover v-slot="{ hover }">
          <!-- TODO Mudar category.name para category.id -->
          <v-btn
            :color="hover ? 'primary' : ''"
            :class="$vuetify.breakpoint.xs ? 'my-1 mr-2' : ''"
            small
            outlined
            text
            @click="allGamesCategory(category.name, category.isViewFavorites)"
            rounded
          >
            {{ category.numberOfGames }}
            {{ $t("newCasino.games") }}
            <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-hover>
      </div>
    </div>

    <!-- Listagem dos jogos -->
    <div
      class="gamesSlider orderGames"
      :class="$vuetify.breakpoint.xs ? 'gridMobile' : 'gridDesktop'"
      :style="{
        gridTemplateColumns: $vuetify.breakpoint.xs
          ? `repeat(${gamesQty}, 1fr)`
          : `repeat(${columnGrid}, 1fr)`,
      }"
    >
      <div v-for="(game, index) in listGames" :key="index">
        <Item
          :categoryName="relatedGames ? '' : category.name"
          :item="game"
          :type="type"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Item from "./item";

export default {
  name: "GridHomeCategory",
  props: ["category", "relatedGames", "providers"],
  components: { Item },
  data: () => ({}),
  created() {
    if (!this.category) {
      return;
    }

    this.category.games.forEach((game) => {
      if (!this.providers) {
        return;
      }

      const provider = this.providers.find(({ id }) => id === game.providerId);

      if (provider) {
        game.providerImage = provider.src;
      }
    });
  },
  computed: {
    type() {
      if (this.$route.params.providerId) {
        return "provider";
      } else if (this.$route.params.category) {
        return "category";
      } else if (this.$route.name === "casinoGameFavorites") {
        return "favorites";
      } else {
        return "lobby";
      }
    },
    listGames() {
      return this.relatedGames ? this.relatedGames : this.category.games;
    },
    gamesQty() {
      // Se a quantidade de jogos for menor que 8, retorna a quantidade de jogos.
      if (this.listGames.length < 8) {
        return this.listGames.length;
      } else {
        // Recupera a quantidade de jogos, divide por dois e arredonda para cima em casos impares.
        return Math.ceil(this.listGames.length / 2);
      }
    },
    columnGrid() {
      switch (this.$vuetify.breakpoint.name) {
        case "sm": // 600 px > < 960 px
        case "md": // 960px > < 1264px*
        case "lg": // 1264px > < 1904px*
        case "xl": // > 1904px*
          return 6;
        default:
          return 6;
      }
    },
  },
  methods: {
    allGamesCategory(category, isViewFavorites) {
      if (isViewFavorites) {
        this.$router.push({ name: "casinoFavorites" });
        return;
      }

      this.$router.push({
        name: "casinoCategory",
        params: { category },
      });
    },
  },
};
</script>
<style scoped>
/* .gamesSlider {
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  scroll-behavior: smooth;
}
.gamesSlider::-webkit-scrollbar {
  display: none;
  width: 0px;
  background: transparent;
} */
.nameCategory:hover {
  color: var(--v-primary-base);
}

.orderGames {
  display: grid;
}
.orderGames.gridMobile {
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  scroll-behavior: smooth;
  gap: 8px;
  padding-left: 8px;
  /* grid-auto-columns: 1fr;   */
}
/* .orderGames.gridMobile div:nth-child(2n) {
  grid-row: 1; 
} */
.orderGames.gridMobile::-webkit-scrollbar {
  display: none;
  width: 0px;
  background: transparent;
}

.orderGames.gridDesktop {
  gap: 16px;
  /* grid-auto-columns: 1fr;   */
}
/* .orderGames.grid {
  grid-template-columns: repeat(6, 1fr);
} */

/* .orderGames.isDesktop {
  grid-template-columns: repeat(4, 1fr);
}
.orderGames.scroll_x div:nth-child(2n) {
  grid-row: 1;
} */
</style>
